import React from 'react';
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";

const ResetAdminPassword = (props) => {
    return (
        <div className='popup-box'>
            <h4 className="title">{props.t('information')}</h4>
            <div className="popup-error-msg">
                {props.t("your_password_has_been_changed_successfully_please_login")}
            </div>
        </div>
    )
}

ResetAdminPassword.propTypes = {
    preGlobalFilteredRows: PropTypes.any,
};

export default withTranslation()(ResetAdminPassword);